import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  SmsPackageInterface,
  setEditId,
  setEditError,
  selectSmsPackageById
} from "src/store/callrecorder/smsPackagesSlice";
import {
  updateSmsPackage,
  fetchSmsPackage
} from "src/actions/callrecorder/smsPackagesActions";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.callrecorder.smsPackages.editId);
  const error   = useAppSelector(state => state.callrecorder.smsPackages.editError);
  const pkg     = useAppSelector(state => selectSmsPackageById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchSmsPackage(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: SmsPackageInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: SmsPackageInterface) {
    const resultAction = await dispatch(updateSmsPackage({ id, data }));

    if (updateSmsPackage.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-sms-package'>
        <h6 className="v-content-label">Edit Package</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={pkg} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
